// extracted by mini-css-extract-plugin
export default {"row":"LocationParametersStyles_row__hpc1E","sizeInput":"LocationParametersStyles_sizeInput__VFHLv"};